<template>
  <section class="table-sampler-result-vibration">
    <template v-for="(row, index) in model">
      <d-form-row class="m-0 mb-1" :key="index">
        <d-col cols="3">
          <label>Norma</label>
          <input
            type="text"
            class="form-control"
            placeholder="Norma"
            v-model="row.norma"
            required
          />
        </d-col>
        <d-col cols="3">
          <label>Critério</label>
          <input
            type="text"
            class="form-control"
            placeholder="Critério"
            v-model="row.criterion"
            required
          />
        </d-col>
        <d-col cols="3">
          <label>Resultado</label>
          <input
            type="text"
            class="form-control"
            placeholder="Resultado"
            v-model="row.result"
            required
          />
        </d-col>
        <d-col cols="3">
          <label>Limite de tolerância</label>
          <input
            type="text"
            class="form-control"
            placeholder="Limite de tolêrancia"
            v-model="row.limit"
            required
          />
        </d-col>
      </d-form-row>
    </template>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { VIBRATION_RESULT, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Vibration',
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(VIBRATION_RESULT),
    };
  },
  methods: {
    setModel() {
      if (this.result) {
        this.model = this.result;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:result', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
